// extracted by mini-css-extract-plugin
export var item = "tireCardCart-module--item--DdvBK";
export var xremove = "tireCardCart-module--xremove--Tok1z";
export var image = "tireCardCart-module--image--V3Tmq";
export var remove = "tireCardCart-module--remove--wa9z2";
export var desc = "tireCardCart-module--desc---cODD";
export var count = "tireCardCart-module--count--hikWr";